<template>
	<div v-if="displayDataEdit">
		<b-container style="margin-top: 10px;">
			<b-row> 
				<b-col cols="8">
					<h3> Certifications </h3>
				</b-col>
				<b-col v-if="!editMode" cols="2" />
				<b-col
					v-if="!editMode"
					cols="1"
					class="date-icon"
				>
					<b-icon 
						v-b-tooltip.hover.top="formatDate(displayDataEdit.asOfDate)"
						icon="clock"
						style="float: right;" 
					/>
				</b-col>

				<b-col 
					v-if="editMode" 
					cols="3"
					class="date-picker"
				>
					<b-form-datepicker
						id="datepicker-sustainability"
						v-model="displayDataEdit.asOfDate"
						size="sm" 
						locale="en" 
						placeholder="Choose a date"
						:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
					/>
				</b-col>

				<b-col
					cols="1"
					class="edit-button"
				>
					<b-button variant="link" @click="edit()">
						Edit
					</b-button>
				</b-col>
			</b-row>

			<b-row>
				<b-col style="height: 15px" />
			</b-row>

			<b-row> 
				<b-col>
					<option-input
						:value="displayDataEdit.LEEDCertification"
						:mode="editMode"
						variable="LEEDCertification"
						:options="LEEDCertOptions"
						label="LEED Certification"
						@update="update"
					/>
				</b-col>
			</b-row>

			<b-row>
				<b-col style="height: 15px" />
			</b-row>

			<b-row> 
				<b-col>
					<option-input
						:value="displayDataEdit.BREEAMCertification"
						:mode="editMode"
						variable="BREEAMCertification"
						:options="BREEAMCertOptions"
						label="BREEAM Certification"
						@update="update"
					/>
				</b-col>
			</b-row>

			<b-row>
				<b-col style="height: 15px" />
			</b-row>

			<b-row> 
				<b-col>
					<option-input
						:value="displayDataEdit.greenGlobesCertification"
						:mode="editMode"
						variable="greenGlobesCertification"
						:options="GreenGlobesCertOptions"
						label="Green Globes Certification"
						@update="update"
					/>
				</b-col>
			</b-row>

			<b-row>
				<b-col style="height: 15px" />
			</b-row>

			<b-row> 
				<b-col>
					<radio-input
						:value="displayDataEdit.PHIUSPlusCertification"
						:mode="editMode"
						variable="PHIUSPlusCertification"
						label="PHIUS+ Certification"
						@update="update"
					/>
				</b-col>
			</b-row>

			<b-row>
				<b-col style="height: 15px" />
			</b-row>

			<b-row> 
				<b-col>
					<option-input
						:value="displayDataEdit.wiredScoreCertification"
						:mode="editMode"
						variable="wiredScoreCertification"
						:options="wiredScoreCertOptions"
						label="WiredScore Certification"
						@update="update"
					/>
				</b-col>
			</b-row>			

			<b-row>
				<b-col style="height: 15px" />
			</b-row>

			<b-row> 
				<b-col>
					<h5> Energy Star </h5>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<radio-input
						:value="displayDataEdit.energyStarCertification"
						:mode="editMode"
						variable="energyStarCertification"
						label="Certified"
						@update="update"
					/>
				</b-col>
				<b-col>
					<field-input
						v-model="displayDataEdit.energyStarScore"
						:mode="editMode"
						label="Score"
					/>
				</b-col>
			</b-row>

			<b-row>
				<b-col style="height: 15px" />
			</b-row>

			<b-row> 
				<b-col>
					<h5> Walk Score </h5>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<field-input
						v-model="displayDataEdit.walkScore"
						:mode="editMode"
						label="Walk Score"
					/>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<field-input
						v-model="displayDataEdit.transitScore"
						:mode="editMode"
						label="Transit Score"
					/>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<field-input
						v-model="displayDataEdit.bikeScore"
						:mode="editMode"
						label="Bike Score"
					/>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<h3> Utilities </h3>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<h5> Net Zero </h5>
				</b-col>
			</b-row>

			<b-row v-if="!editMode">
				<b-col>
					<div class="net-zero-asset">
						<div style="flex: 1; padding-left: 15px;">
							<b>Net Zero Building</b>
						</div>
						<div style="flex: 1; text-align: right;">
							<b-icon
								v-if="!displayDataEdit.netZeroAsset"
								class="h4 check-icon"
								icon="check-circle-fill"
								style="color: #C4C4C4;"
							/>
							<b-icon
								v-if="displayDataEdit.netZeroAsset"
								class="h4 check-icon"
								icon="check-circle-fill"
								variant="secondary"
							/>
						</div>
					</div>
				</b-col>
			</b-row>

			<b-row v-if="editMode">
				<b-col>
					Certified
					<b-form-radio-group
						v-model="displayDataEdit.netZeroAsset"
						:options="[{ text: 'Yes', value: true },{ text: 'No', value: false }]"
					/>
				</b-col>
			</b-row>

			<b-row>
				<b-col style="height: 15px" />
			</b-row>

			<b-row> 
				<b-col>
					<h5> Electricity </h5>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<field-input
						v-model="displayDataEdit.electricityAnnualCost"
						:mode="editMode"
						:step="0.01"
						label="Annual Cost"
						unit="$"
					/>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<field-input
						v-model="displayDataEdit.electricityAnnualConsumption"
						:mode="editMode"
						:step="0.01"
						label="Annual Consumption"
						unit="kWh"
					/>
				</b-col>
				<b-col>
					<field-input
						v-model="displayDataEdit.annualOnSiteProduction"
						:mode="editMode"
						:step="0.01"
						label="Annual On Site Production"
						unit="kWh"
					/>
				</b-col>
			</b-row>

			<b-row>
				<b-col style="height: 15px" />
			</b-row>

			<b-row> 
				<b-col>
					<h5> Natural Gas </h5>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<field-input
						v-model="displayDataEdit.naturalGasAnnualCost"
						:mode="editMode"
						:step="0.01"
						label="Annual Cost"
						unit="$"
					/>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<field-input
						v-model="displayDataEdit.naturalGasAnnualConsumption"
						:mode="editMode"
						:step="0.01"
						label="Annual Consumption"
						unit="MCF"
					/>
				</b-col>
			</b-row>

			<b-row>
				<b-col style="height: 15px" />
			</b-row>

			<b-row> 
				<b-col>
					<h5> Water </h5>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<field-input
						v-model="displayDataEdit.waterAnnualCost"
						:mode="editMode"
						:step="0.01"
						label="Annual Cost"
						unit="$"
					/>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<field-input
						v-model="displayDataEdit.waterAnnualConsumption"
						:mode="editMode"
						:step="0.01"
						label="Annual Consumption"
						unit="MCF"
					/>
				</b-col>
			</b-row>

			<b-row>
				<b-col style="height: 15px" />
			</b-row>

			<b-row> 
				<b-col>
					<h5> Sewage </h5>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<field-input
						v-model="displayDataEdit.annualGreyWaterProduction"
						:mode="editMode"
						:step="0.01"
						label="Annual Grey Water Production"
						unit="GAL"
					/>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<field-input
						v-model="displayDataEdit.annualBlackWaterProduction"
						:mode="editMode"
						:step="0.01"
						label="Annual Black Water Production"
						unit="MCF"
					/>
				</b-col>
			</b-row>

			<b-row>
				<b-col style="height: 15px" />
			</b-row>

			<b-row> 
				<b-col>
					<h5> Waste </h5>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<field-input
						v-model="displayDataEdit.annualGarbageProduction"
						:mode="editMode"
						:step="0.01"
						label="Annual Garbage Production"
						unit="T"
					/>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<field-input
						v-model="displayDataEdit.annualRecyclingProduction"
						:mode="editMode"
						:step="0.01"
						label="Annual Recycling Production"
						unit="T"
					/>
				</b-col>
			</b-row>

			<b-row>
				<b-col style="height: 15px" />
			</b-row>

			<b-row> 
				<b-col>
					<h5> Carbon </h5>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<field-input
						v-model="displayDataEdit.annualCarbonProduced"
						:mode="editMode"
						:step="0.01"
						label="Annual Carbon Protected"
						unit="CO2e"
					/>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<field-input
						v-model="displayDataEdit.annualCarbonSequestered"
						:mode="editMode"
						:step="0.01"
						label="Annual Recycling Sequestered"
						unit="CO2e"
					/>
				</b-col>
			</b-row>

			<b-row>
				<b-col style="height: 15px" />
			</b-row>

			<b-row> 
				<b-col>
					<h5> Transportation </h5>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<h5> Annual Tips Created </h5>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<field-input
						v-model="displayDataEdit.pedestrian"
						:mode="editMode"
						label="Pedestrian"
					/>
				</b-col>
				<b-col>
					<field-input
						v-model="displayDataEdit.cycling"
						:mode="editMode"
						label="Cycling"
					/>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<field-input
						v-model="displayDataEdit.publicTransport"
						:mode="editMode"
						label="Public Transport"
					/>
				</b-col>
				<b-col>
					<field-input
						v-model="displayDataEdit.automotive"
						:mode="editMode"
						label="Automotive"
					/>
				</b-col>
			</b-row>

			<b-row>
				<b-col style="height: 15px" />
			</b-row>

			<b-row> 
				<b-col>
					<h5> Micromobility </h5>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<field-input
						v-model="displayDataEdit.bikeshareStations"
						:mode="editMode"
						label="Bikeshare Stations"
					/>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					<field-input
						v-model="displayDataEdit.bicycleParkingSpots"
						:mode="editMode"
						label="Bicycle Parking Sports"
					/>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import FieldInput from './FieldInput.vue';
import OptionInput from './OptionInput.vue';
import RadioInput from './RadioInput.vue';

export default {
	name: 'AssetSustainability',
	components: {FieldInput, OptionInput, RadioInput},
	filters: {},
	props: {},
	data() {
		return {
			editMode: false,
			displayDataEdit: {},
			LEEDCertOptions: [
				{ text: 'Certified', value: 'Certified' },
				{ text: 'Silver', value: 'Silver' },
				{ text: 'Gold', value: 'Gold' },
				{ text: 'Platinum', value: 'Platinum' },
				{ text: 'Uncertified', value: 'Uncertified' }
			],
			BREEAMCertOptions: [
				{ text: 'Pass', value: 'Pass' },
				{ text: 'Good', value: 'Good' },
				{ text: 'Very Good', value: 'Very Good' },
				{ text: 'Excellent', value: 'Excellent' },
				{ text: 'Outstanding', value: 'Outstanding' },
				{ text: 'Uncertified', value: 'Uncertified' }
			],
			GreenGlobesCertOptions: [
				{ text: '1 Green Globes', value: '1 Green Globes' },
				{ text: '2 Green Globes', value: '2 Green Globes' },
				{ text: '3 Green Globes', value: '3 Green Globes' },
				{ text: '4 Green Globes', value: '4 Green Globes' },
				{ text: '5 Green Globes', value: '5 Green Globes' },
				{ text: 'Uncertified', value: 'Uncertified' }
			],
			wiredScoreCertOptions: [
				{ text: 'Certified', value: 'Certified' },
				{ text: 'Silver', value: 'Silver' },
				{ text: 'Gold', value: 'Gold' },
				{ text: 'Platinum', value: 'Platinum' },
				{ text: 'Under Certification', value: 'Under Certification' },
				{ text: 'Uncertified', value: 'Uncertified' }
			]
		};
	},
	computed: {
		...mapState(['elementEditorEntityDataId']),
		formatDate() {
			return date => (!date || date === '') ? `Not updated`: new Intl.DateTimeFormat('en-US', { dateStyle: 'long' }).format(new Date(date.replace(/-/g, '/').replace(/T.+/, ''))) 
		}
	},
	watch: {
		elementEditorEntityDataId: {
			immediate: true,
			deep: true,
			handler() {
				this.getData();
			},
		},
		displayDataEdit: {
			deep: true,
			handler() {
				this.updateData();
			},
		},
		data: {
			immediate: true,
			handler(newVal) {
				this.displayDataEdit = newVal;
			},
		}
	},
	created() {
		
	},
	mounted() {
	},
	methods: {
		edit() {
			this.editMode = !this.editMode;
		},
		async getData() {
			const assetscheduleData = await this.axios.get(
				`/entities/${this.elementEditorEntityDataId}/assetsustainabilities`
			);
			this.displayDataEdit = assetscheduleData.data;
		},
		async updateData() {
			if (this.displayDataEdit && this.displayDataEdit.id) {
				const postAssetScheduleModelData = await this.axios.patch(
					`/assetsustainabilities/${this.displayDataEdit.id}`,
					this.displayDataEdit
				);
			}
		},
		update(variable, value) {
			this.displayDataEdit[`${variable}`] = value;
		}
	},
};
</script>

<style scoped>
div.net-zero-asset {
	display: flex;
	border-radius: 12px;
    border: 1px solid #000000;
	background-color: #ffffff;
	line-height: 42px;
}
.date-icon {
	margin-top: auto;
	margin-bottom: auto;
	padding-right: 5px;
}
.check-icon {
	margin-right: 15px;
	margin-top: auto;
	margin-bottom: auto;
	vertical-align: middle !important;
}
.date-picker {
	margin-top: auto;
	margin-bottom: auto;
	padding: 0px;
}
.edit-button {
	margin-top: auto;
	margin-bottom: auto;
	padding: 0px 0px 0px 3px;
}
</style>
